import { IEscrowJournalEntryData } from '../../types/accounting/data/IEscrowJournalEntryData';
import { APIFactory } from '../../ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from '../../ui-toolkit/rest/axiosErrorHandler';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';
import { IUpdateJournalEntryRequest } from '../../types/accounting/IUpdateJournalEntryRequest';

export const updateJournalEntryAsync = async (
  id: string,
  journalEntry: IUpdateJournalEntryRequest
): Promise<IEscrowJournalEntryData | Error> =>
  APIFactory(baseUrlService.ApiLocation)
    .put<IEscrowJournalEntryData>(`/timber/api/internal/escrow/journal_entries/${id}`, journalEntry)
    .then((response) => response.data)
    .catch(axiosErrorHandler);
